export const aside = {
    search: {
        placeholder: "ex : Largo Winch", 
        title: "Veuillez renseigner le nom d'un patient"
    },
    searching: 'recherche en cours…',
    'patient-title': "Accéder au rendez-vous de {first_name} {last_name}",
    result: 'aucun résultat | {count} résultat | {count} résultats'
}